




































































































































import { Search } from '@/data/models/search.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import store, { State } from '@/store';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Actor } from '@/data/models/actor.model';
import { Veicolo } from '@/data/models/veicolo.model';
import { ServiceInstance, ServiceInstanceStatus } from '@/data/models/serviceinstance.model';
import { dateEndofDay, dateStartofDay } from '@/data/utils/helper';
import { Tipologiaintervento } from '@/data/models/tipologiaintervento.model';
import { Contatto } from '@/data/models/contatto.model';

@Component
export default class CalendarioServiziFilter extends Vue {

	@Prop() serviceinstance!: ServiceInstance;

	advancedSearch: Search;
	searchParam: any = new class {
		rangeFilter!: {start: number; stop: number};
		operator?: Actor;
		patient?: Actor;
		type?: number | null = null;
		status?: ServiceInstanceStatus;
		servicetype?: string;
	};

	advancedSearchDriver = new Search('actor');
	actorClass: ClassType<Actor> = Actor;

	advancedSearchPatient = new Search('actor');

	statuses = Object.keys(ServiceInstanceStatus).map(
		// @ts-ignore
		(k: string) => ServiceInstanceStatus[k]
	);

	interventoClass: ClassType<Tipologiaintervento> = Tipologiaintervento;

	state!: State;
	dates: Date[] = [];
	selected: Date[] = [];
	
	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('serviceinstance');
		this.advancedSearchPatient.addNotEqualFilter('patientid', null);
		this.advancedSearchPatient.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.advancedSearchDriver.addSimpleFilter('candrive', 1);
		this.advancedSearchDriver.addNotEqualFilter('volunteerid', null);
		this.advancedSearchDriver.addSimpleFilter('hqid', this.state.headquarter!.id);
	}

	mounted() {
		this.setTodayRange();
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.rangeFilter) this.advancedSearch.addRangeFilter('startdate', this.searchParam.rangeFilter.start, this.searchParam.rangeFilter.stop);
		else this.advancedSearch.removeSimpleFilter('startdate');

		if (this.searchParam.operator && this.searchParam.operator.id) this.advancedSearch.addSimpleFilter('driverid', this.searchParam.operator.id);
		else this.advancedSearch.removeSimpleFilter('driverid');

		if (this.searchParam.patient && this.searchParam.patient.id) this.advancedSearch.addSimpleFilter('patientid', this.searchParam.patient.id);
		else this.advancedSearch.removeSimpleFilter('patientid');

		if (this.searchParam.type) this.advancedSearch.addSimpleFilter('periodicflag', this.searchParam.type);
		else this.advancedSearch.removeSimpleFilter('periodicflag');

		if (this.searchParam.status) this.advancedSearch.addSimpleFilter('status', this.searchParam.status);
		else this.advancedSearch.removeSimpleFilter('status');

		if (this.searchParam.servicetype) this.advancedSearch.addSimpleFilter('servicetype', this.searchParam.servicetype);
		else this.advancedSearch.removeSimpleFilter('servicetype');

		this.$emit('search', this.advancedSearch);
	}

	onDatesChange(event: Date[]) {
		const start = Math.round(dateStartofDay(event[0]).getTime() / 1000);
		const stop = Math.round(dateEndofDay(event[1]).getTime() / 1000);
		this.searchParam.rangeFilter = { start: start, stop: stop };
	}

	setTodayRange() {
		const nowstart = new Date();
		nowstart.setHours(0,0,0);
		const nowend = new Date();
		nowend.setHours(23,59,59);
		this.dates = [nowstart, nowend];
		this.onDatesChange(this.dates);
	}

	dayNext() {
		this.dates[0].setDate(this.dates[0].getDate() + 1);
		this.dates[1].setDate(this.dates[1].getDate() + 1);
		this.dates = [...this.dates];
		this.onDatesChange(this.dates);
		this.search();
	}

	dayBefore() {
		this.dates[0].setDate(this.dates[0].getDate() - 1);
		this.dates[1].setDate(this.dates[1].getDate() - 1);
		this.dates = [...this.dates];
		this.onDatesChange(this.dates);
		this.search();
	}

	reset() {
		this.searchParam.rangeFilter = undefined;
		this.searchParam.vehicle = {};
		this.searchParam.operator = {};
		this.searchParam.patient = {};
		this.searchParam.type = null;
		this.searchParam.status = undefined;
		this.searchParam.servicetype = undefined;
		this.setTodayRange();
		this.search();
	}

	contactFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.address ? contact.address : ''} ${contact.streetno ? contact.streetno : ''}`;
		}
	}

	operatoreFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
	}
}

